import { render, staticRenderFns } from "./dppplan.vue?vue&type=template&id=8bbc0bb2&scoped=true&"
import script from "./dppplan.vue?vue&type=script&lang=js&"
export * from "./dppplan.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./dppplan.vue?vue&type=style&index=1&id=8bbc0bb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbc0bb2",
  null
  
)

export default component.exports